import { render } from "./NcrmLastCallCell.vue?vue&type=template&id=265db07a&scoped=true"
import script from "./NcrmLastCallCell.vue?vue&type=script&lang=js"
export * from "./NcrmLastCallCell.vue?vue&type=script&lang=js"

import "./NcrmLastCallCell.vue?vue&type=style&index=0&id=265db07a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265db07a"]])

export default __exports__